import styled from "@emotion/styled";
import React from "react";

import { LeadFormController } from "@brexhq/next/src/components/modules/LeadForm/LeadformController";
import { FormType } from "@brexhq/next/src/components/modules/LeadForm/sharedTypes";
import { BynderImage } from "@brexhq/next/src/components/shared/BynderAsset/Image/BynderImage";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { SubtitleL } from "@brexhq/shared/components/Typography/Components";
import { SanityCreditCardBlockProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

const HeaderWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.background.secondary,
  display: "flex",
  flexDirection: "row",
  [theme.breakpoints.phone]: {
    flexDirection: "column-reverse",
  },
}));

const HeaderTextWrapper = styled.div(({ theme }) => ({
  flex: 1,
  padding: theme.spacing[24],
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[8],
  [theme.breakpoints.phone]: {
    padding: theme.spacing[16],
  },
}));

const HeaderDescription = styled.p(({ theme }) => ({
  color: theme.colors.content.tertiary,
  margin: 0,
}));

const HeaderCTA = styled(Link)({
  margin: 0,
  minWidth: "unset",
});

const HeaderImageWrapper = styled.div(({ theme }) => ({
  width: "100%",
  maxWidth: "312px",
  [theme.breakpoints.tabletLandscape]: {
    maxWidth: "200px",
  },
  [theme.breakpoints.phone]: {
    maxWidth: "100%",
    height: "168px",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

type CreditCardBlockHeaderProps = Pick<
  SanityCreditCardBlockProps,
  | "title"
  | "description"
  | "image"
  | "htmlTagOverride"
  | "creditCardBlockCta"
  | "leadForm"
>;

export const CreditCardBlockHeader = ({
  title,
  description,
  image,
  htmlTagOverride,
  creditCardBlockCta,
  leadForm,
}: CreditCardBlockHeaderProps) => {
  return (
    <HeaderWrapper>
      <HeaderTextWrapper>
        <SubtitleL as={htmlTagOverride || "h3"} fontWeightOverride="BODY">
          {title}
        </SubtitleL>
        {description && (
          <HeaderDescription as="p">{description}</HeaderDescription>
        )}
        {creditCardBlockCta && (
          <HeaderCTA
            {...creditCardBlockCta}
            size={{ LRG: "sml", MED: "sml", SML: "sml" }}
            modifier="primary"
            component="credit-card-block-cta"
          />
        )}
        {leadForm && (
          <LeadFormController
            data={{ ...leadForm, formType: FormType.GTM_LEAD_FORM }}
          />
        )}
      </HeaderTextWrapper>
      <HeaderImageWrapper>
        <BynderImage image={image} />
      </HeaderImageWrapper>
    </HeaderWrapper>
  );
};
